module.exports = __webpack_public_path__ + "media/car.7301d044.mp4";